import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { getFormattedDate } from 'lib/common';
import {
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import {
  ApiDownloadButton,
  FileLink,
  TimeIndicator,
  Tooltip
} from 'components/common';
import { CalendarEventAttachmentsRemove } from '.';

import type { CalendarEventExtended } from 'shared-types';

interface Props {
  attachments: CalendarEventExtended['attachments'];
  updateFiles: () => Promise<void>;
}

const CalendarEventAttachmentsList = ({ attachments, updateFiles }: Props) => {
  const { language, messages, theme } = useReduxState();

  if (!attachments.length) return null;

  return (
    <BoxTable>
      <BoxTableHeader hideAtBreakpoint={breakpoints.medium}>
        <BoxTableCell>{messages.commonFilename}</BoxTableCell>
        <BoxTableCell>{messages.commonAdded}</BoxTableCell>
        <BoxTableCell shrink={true}></BoxTableCell>
      </BoxTableHeader>

      {attachments.map((attachment) => (
        <BoxTableRow key={attachment.id}>
          <BoxTableCell>
            <FileLink name={attachment.filename} url={attachment.fileUrl} />
          </BoxTableCell>
          <BoxTableCell>
            <Tooltip content={getFormattedDate({ date: attachment.createdAt })}>
              <div style={{ fontWeight: 400, whiteSpace: 'nowrap' }}>
                <TimeIndicator
                  language={language}
                  timeString={attachment.createdAt as string}
                />
              </div>
            </Tooltip>
          </BoxTableCell>
          <BoxTableCell shrink={true}>
            <div style={{ display: 'flex', gap: 10 }}>
              <ApiDownloadButton
                category="lighter"
                external={true}
                icon="download"
                filename={`${attachment.filename}.${attachment.extension}`}
                size="small"
                tooltip={messages.commonDownloadFile}
                url={attachment.fileUrl}
              />

              <CalendarEventAttachmentsRemove
                attachmentId={attachment.id}
                iconOnly={true}
                updateFiles={updateFiles}
              />
            </div>
          </BoxTableCell>
        </BoxTableRow>
      ))}
    </BoxTable>
  );
};

export default CalendarEventAttachmentsList;
